import { Card, CardBody } from '@img/ui';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

/**
 * © حقوق الملكية الفكرية — شركة صورة العقارية
 */
export function CopyrightPage() {
  return (
    <div className="bg-gradient-to-b from-navy-soft/30 to-white">
      <SEO
        title="حقوق الملكية الفكرية — شركة صورة العقارية ©"
        description="جميع محتويات منصة شركة صورة العقارية (الشعار، التصميم، النصوص، الكود، قواعد البيانات، المقالات) محمية بنظام حماية حقوق المؤلف ونظام العلامات التجارية في المملكة العربية السعودية. العقار بصورة جديدة."
        keywords="حقوق الملكية الفكرية, حقوق المؤلف السعودية, نظام العلامات التجارية, براءات اختراع, حقوق صورة العقارية, حماية المحتوى الرقمي, الملكية الفكرية في السعودية, الهيئة السعودية للملكية الفكرية SAIP, حقوق نشر img.sa, شركة صورة العقارية, العقار بصورة جديدة"
        canonical="https://img.sa/copyright"
        jsonLd={{
          '@type': 'WebPage',
          name: 'حقوق الملكية الفكرية',
          url: 'https://img.sa/copyright',
          about: { '@type': 'Thing', name: 'حماية حقوق الملكية الفكرية لمنصة شركة صورة العقارية' },
        }}
      />
      <section className="bg-gradient-to-l from-navy-darker via-navy-dark to-navy text-white py-14 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-6xl mb-3">©</div>
          <h1 className="text-3xl md:text-4xl font-black mb-3">حقوق الملكية الفكرية</h1>
          <p className="text-gold-light text-base leading-relaxed max-w-2xl mx-auto">
            كل ما تشاهده على منصّة <b>شركة صورة العقارية</b> محمي بموجب نظام حماية حقوق المؤلف
            ونظام العلامات التجارية في المملكة العربية السعودية.
          </p>
          <p className="text-gray-400 text-sm mt-4">آخر تحديث: محرّم ١٤٤٧ هـ</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-10 space-y-5">
        <Card><CardBody>
          <p className="text-sm text-gray-700 leading-relaxed">
            تحتفظ <b>شركة صورة العقارية</b> بكامل الحقوق الفكرية على المنصّة وكل ما يتفرّع منها،
            وتلتزم في الوقت ذاته بحماية حقوق المُعلِنين والمستخدمين الذين يساهمون بالمحتوى عليها.
          </p>
        </CardBody></Card>

        <Section n="1" title="الحقوق المملوكة لشركة صورة العقارية">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li><b>الاسم التجاري:</b> «شركة صورة العقارية» وكل تصاريفه ومرادفاته بالعربية والإنجليزية.</li>
            <li><b>الشعار:</b> رمز ولوقو img.sa بكل أشكاله وتدرّجاته اللونية.</li>
            <li><b>التصميم:</b> الواجهات، الألوان، الخطوط، الأيقونات، تجربة المستخدم (UX).</li>
            <li><b>الكود البرمجي:</b> الواجهات الأمامية، الـ APIs، قواعد البيانات، الخوارزميات الخاصة.</li>
            <li><b>المحتوى التحريري:</b> النصوص التعريفية، المقالات، الأدلة، الأسئلة الشائعة.</li>
            <li><b>الحاسبات والأدوات:</b> حاسبات الرهن، الزكاة، عمولة الوسيط، وأي أدوات حصرية.</li>
            <li><b>قواعد البيانات المجمَّعة:</b> أرشيف العقارات، نتائج المزادات، تحليلات السوق.</li>
          </ul>
        </Section>

        <Section n="2" title="حقوق المُعلِنين على عقاراتهم">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>الصور والفيديوهات والأوصاف التي يرفعها المُعلِن تبقى ملكاً له.</li>
            <li>بنشرك المحتوى على المنصة، تمنح شركة صورة العقارية رخصة <b>غير حصرية</b> و<b>قابلة للإلغاء</b> لاستخدامه:
              <ul className="list-disc pr-6 mt-1 space-y-1">
                <li>عرضه ضمن نتائج البحث والخريطة وصفحات العقار.</li>
                <li>استخدامه في إعلانات تسويقية لخدمات المنصة بإذن مسبق.</li>
                <li>أرشفته للأغراض الفنية والقانونية ضمن مدة الاحتفاظ المعتمدة.</li>
              </ul>
            </li>
            <li>عند حذف الإعلان، تنتهي رخصة العرض العامة، مع احتفاظ المنصة بنسخة أرشيفية للأغراض النظامية فقط.</li>
            <li>المُعلِن مسؤول مسؤولية كاملة عن كونه يملك حقوق المحتوى الذي يرفعه (لم يُسرَق من موقع آخر).</li>
          </ul>
        </Section>

        <Section n="3" title="ما يُسمَح به (الاستخدام العادل)">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>اقتباس فقرات قصيرة من المقالات لأغراض الاستشهاد، مع ذكر المصدر ووضع رابط للمقال.</li>
            <li>مشاركة روابط الإعلانات والعقارات على وسائل التواصل أو في المراسلات الخاصة.</li>
            <li>التقاط لقطات شاشة لأغراض شخصية أو إخبارية مع إبراز شعار المنصة.</li>
            <li>الاستخدام التعليمي/البحثي في النطاق غير التجاري مع الإسناد الصحيح.</li>
          </ul>
        </Section>

        <Section n="4" title="ما هو محظور">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>إعادة نشر بيانات العقارات على مواقع أخرى دون إذن خطّي.</li>
            <li>استخدام برامج آلية (Scrapers / Bots) لاستخراج المحتوى.</li>
            <li>تقليد الشعار أو التصميم بشكل قد يُربك المستخدمين أو يوحي بانتساب غير حقيقي للمنصة.</li>
            <li>استخدام محتوى المنصة في أي مادة دعائية لطرف ثالث دون اتفاقية موقّعة.</li>
            <li>تعديل الكود البرمجي أو هندسته العكسية أو محاولة الوصول لقواعد البيانات بطرق غير مصرَّح بها.</li>
          </ul>
        </Section>

        <Section n="5" title="الإبلاغ عن مخالفة (Takedown)">
          <p className="text-sm text-gray-700 leading-relaxed mb-3">
            إذا اعتقدت أن محتوى منشوراً على المنصة ينتهك حقوقك (صورة لعقارك، نص مقال، شعار، تصميم...)،
            راسلنا متضمّناً الآتي:
          </p>
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>وصف دقيق للعمل المحمي الذي تدّعي ملكيته.</li>
            <li>رابط الصفحة/المحتوى المخالف على img.sa.</li>
            <li>إثبات الملكية (شهادة، توثيق، ملف أصلي بتاريخ سابق...).</li>
            <li>بياناتك الكاملة (الاسم، رقم الهوية أو السجل التجاري، الجوال).</li>
            <li>إقرار خطي بصحة المعلومات.</li>
          </ul>
          <p className="text-sm text-gray-700 leading-relaxed mt-3">
            راسلنا على <a href="mailto:info@img.sa" className="text-navy hover:underline font-bold" dir="ltr">info@img.sa</a> —
            نتعهّد بمراجعة البلاغ خلال ٧٢ ساعة، وإزالة المحتوى المخالف فوراً عند ثبوته، مع إشعار صاحب الإعلان.
          </p>
        </Section>

        <Section n="6" title="العلامات التجارية الخارجية">
          <p className="text-sm text-gray-700 leading-relaxed">
            بعض الأسماء والشعارات الظاهرة على المنصة (REGA، فال، STC Pay، آبل باي، Hostinger، إلخ) ملك لأصحابها الأصليين،
            وتُعرَض ضمن سياق إعلامي/تشغيلي فقط ولا تعني أي رعاية أو شراكة لم يُعلَن عنها صراحةً.
          </p>
        </Section>

        <Section n="7" title="العقوبات على الانتهاك">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>إزالة المحتوى المخالف وإغلاق الحساب فوراً.</li>
            <li>المطالبة بتعويض مادي عن الأضرار وفق نظام حماية حقوق المؤلف السعودي.</li>
            <li>إحالة الحالة لهيئة الاتصالات وتقنية المعلومات أو النيابة العامة عند الجرائم الإلكترونية.</li>
          </ul>
        </Section>

        <Section n="8" title="التواصل بشأن حقوق الملكية">
          <p className="text-sm text-gray-700 leading-relaxed">
            📧 <a href="mailto:info@img.sa" className="text-navy hover:underline" dir="ltr">info@img.sa</a>
            <br />📞 <a href="tel:0114993666" className="text-navy hover:underline" dir="ltr">0114993666</a>
            <br />📍 الرياض، المملكة العربية السعودية
          </p>
          <p className="text-sm text-gray-700 leading-relaxed mt-3">
            راجع كذلك <Link to="/terms" className="text-navy hover:underline">الشروط والأحكام</Link> و
            <Link to="/privacy" className="text-navy hover:underline mr-1">سياسة الخصوصية</Link>.
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ n, title, children }: { n: string; title: string; children: React.ReactNode }) {
  return (
    <Card>
      <CardBody>
        <h2 className="text-lg font-black text-navy-dark mb-3 flex items-center gap-2">
          <span className="inline-flex items-center justify-center w-8 h-8 bg-navy text-white rounded-lg text-sm">{n}</span>
          {title}
        </h2>
        {children}
      </CardBody>
    </Card>
  );
}
